import progressStepsDesktopGif from './progress-steps-desktop.gif';
import progressStepsMobileGif from './progress-steps-mobile.gif';

export const progressStepsDesktopSources = [progressStepsDesktopGif];
export const progressStepsMobileSources = [progressStepsMobileGif];
